import { useAppSelector } from "integrations/redux/hooks"
import { useMemo, useRef } from "react"
import { useDispatch } from "react-redux"
import {
    ContextMenu,
    ContextMenuItem,
} from "features/data-management/workspace/TODO-put-in-package/ContextMenu"
import * as Icons from "@nova/component-icons"
import { setActiveContextMenu } from "features/popups/slice"
import { selectActiveContextMenu } from "features/popups/contextMenu"
import { ContentSortDirection, ContentSortMode } from "@nova/constants"
import { useLocalStorageValue, setLocalStorageValue } from "tools/store/localStorageRegistry"

const optionDisplayNameMapping = {
    Name: "Alphabetical",
    DateModified: "Last modified",
    DateCreated: "Date created",
    Ascending: "Ascending",
    Descending: "Descending",
}

const contextMenuSectionHeaders = ["Sort by", "Order"]

export const SortableDropdown = () => {
    const buttonRef = useRef<HTMLButtonElement | null>(null)
    const dispatch = useDispatch()
    const selectedSortMode = useLocalStorageValue("workspace-content-sort-mode")
    const selectedSortDirection = useLocalStorageValue("workspace-content-sort-dir")
    const activeWorkspaceSortContextMenu = useAppSelector(selectActiveContextMenu("WorkspaceSort"))

    const contextMenuSections: ContextMenuItem[][] = useMemo(() => {
        const sections: ContextMenuItem[][] = []
        sections.push(
            Object.keys(ContentSortMode).map((sortMode) => {
                return {
                    title: optionDisplayNameMapping[
                        sortMode as keyof typeof optionDisplayNameMapping
                    ],
                    Icon:
                        selectedSortMode ===
                        ContentSortMode[sortMode as keyof typeof ContentSortMode]
                            ? Icons.Checkmark
                            : null,
                    onClick: (e) => {
                        e.stopPropagation()
                        setLocalStorageValue(
                            "workspace-content-sort-mode",
                            ContentSortMode[sortMode as keyof typeof ContentSortMode]
                        )
                    },
                }
            })
        )
        sections.push(
            Object.keys(ContentSortDirection).map((sortDirection) => {
                return {
                    title: optionDisplayNameMapping[
                        sortDirection as keyof typeof optionDisplayNameMapping
                    ],
                    Icon:
                        selectedSortDirection ===
                        ContentSortDirection[sortDirection as keyof typeof ContentSortDirection]
                            ? Icons.Checkmark
                            : null,
                    onClick: (e) => {
                        e.stopPropagation()
                        setLocalStorageValue(
                            "workspace-content-sort-dir",
                            ContentSortDirection[sortDirection as keyof typeof ContentSortDirection]
                        )
                    },
                }
            })
        )
        return sections
    }, [selectedSortDirection, selectedSortMode])

    return (
        <>
            <button
                onClick={(e) => {
                    if (activeWorkspaceSortContextMenu) {
                        return
                    }
                    e.stopPropagation()
                    const boundingClientRect = buttonRef.current?.getBoundingClientRect()
                    dispatch(
                        setActiveContextMenu({
                            type: "WorkspaceSort",
                            position: {
                                top: (boundingClientRect?.y || 0) + 24,
                                left:
                                    (boundingClientRect?.x || 0) + (boundingClientRect?.width || 0),
                            },
                        })
                    )
                }}
                ref={buttonRef}
                className="flex justify-center items-center"
            >
                Sort by:
                <Icons.ArrowDropDownIcon
                    dropdownOpen={!!activeWorkspaceSortContextMenu}
                    setDropdownOpen={() => null}
                />
            </button>
            {activeWorkspaceSortContextMenu && (
                <ContextMenu
                    sections={contextMenuSections}
                    sectionHeaders={contextMenuSectionHeaders}
                    onBlur={() => dispatch(setActiveContextMenu(undefined))}
                    isFixedPosition={true}
                    top={activeWorkspaceSortContextMenu.position.top}
                    left={activeWorkspaceSortContextMenu.position.left}
                    style={{
                        transform: "translateX(-100%)",
                    }}
                    keepOpenOnSelect
                    iconColor="#16C949" // green-500
                />
            )}
        </>
    )
}
